// Shared share-preview / SEO meta management for the client side.
//
// Social crawlers (WhatsApp, Telegram, Facebook, X) do not execute JavaScript:
// for them the nginx edge server injects per-route tags server-side. This
// helper keeps the browser-side tags (tab title, in-app shares, client-side
// navigations) in sync with the same values.

const SITE_NAME = "FLIP";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function setShareMeta({ title, description, image, url, type = "website", robots = "index,follow" }) {
  document.title = title;
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:type", type);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:image", image);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:site", "@backonflip_");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
  setMeta("name", "robots", robots);
  if (url) {
    setMeta("property", "og:url", url);
    setCanonical(url);
  }
}

export function backendOrigin() {
  return (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
}
